<template>
  <!--    <div id="app" :class="$route.name">-->
  <!--        <b-navbar toggleable="lg" type="light" style="background-color: #ffffff">-->

  <!--           <b-navbar-brand href="#">-->
  <!--                <img src="../assets/epg_migration_logo.png" alt="EPG Migration Logo"-->
  <!--                                          class="logo"/>-->
  <!--            </b-navbar-brand>-->

  <!--            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>-->

  <!--            <b-collapse id="nav-collapse" is-nav>-->

  <!--                <b-navbar-nav>-->
  <!--                    <b-nav-text class="text-left">-->
  <!--                       <small style="color: #2A1EAA">Fee Agreement</small>-->
  <!--                        <h6 style="color:#2c3e50">{{ projectName }}</h6>-->
  <!--                    </b-nav-text>-->
  <!--                </b-navbar-nav>-->

  <!--                <b-navbar-nav class="ml-auto">-->

  <!--                    <b-nav-form>-->
  <!--                        <b-button size="sm" @click.prevent="$refs.contactUsFormModal.show()">-->
  <!--                            <font-awesome-icon icon="question-circle" class="mr-1" /> Request Assistance-->
  <!--                        </b-button>-->
  <!--                    </b-nav-form>-->

  <!--                  <b-nav-form>-->
  <!--                       <b-button size="sm" @click="navigateToClientPortal()">Back to Fee agreements</b-button>-->
  <!--                  </b-nav-form>-->

  <!--                </b-navbar-nav>-->

  <!--            </b-collapse>-->

  <!--        </b-navbar>-->

  <!--        <div class="main-content">-->
  <!--            <b-container>-->
  <!--                <router-view></router-view>-->
  <!--            </b-container>-->
  <!--        </div>-->

  <!--        <contact-us-form-modal ref="contactUsFormModal" />-->
  <!--    </div>-->

  <!--  <div class="h-screen bg-white overflow-hidden dark:bg-darkSecondary">-->
  <!--    -->
  <!--    <div class="w-full">-->
  <!--      <div :class="`bg-gray-100 dark:bg-darkPrimary mx-4 mb-4 rounded-md relative pt-4 lg:pt-0 px-4 overflow-x-hidden overflow-y-auto fullWidth-contentHeight`">-->
  <!--        <div class="mx-auto max-w-screen-1920">-->
  <!--          <router-view></router-view>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      <div class="mx-auto max-w-screen-1920 px-8">-->
  <!--        <div class="grid grid-cols-12 gap-4">-->
  <!--          <div class="col-start-1 lg:col-start-2 col-span-12 lg:col-span-10">-->
  <!--            <div class="flex justify-center">-->
  <!--              <a href="/application-business/" class="btn btn&#45;&#45;primary">Get Started</a>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->

  <div class="h-screen bg-white overflow-hidden dark:bg-darkSecondary" id="app">
    <div class="mx-auto flex justify-center items-center p-4">
      <a
        @click="navigateToClientPortal"
        class="flex text-blue-500 cursor-pointer"
      >
        <ChevronLeftIcon size="1.5x" class="mt-0.5 text-black" />
        <span class="hidden md:block">Fee Agreements</span>
      </a>

      <button
        v-if="showFooter"
        :class="`btn btn--default mr-2 text-black invisible ${
          needHelpButton.isClicked
            ? 'disabled opacity-20 cursor-not-allowed'
            : ''
        }`"
      >
        Need Help?
      </button>

      <div class="flex justify-center flex-1">
        <div class="flex flex-shrink-0 transition-all ease-in-out">
          <a class="flex hover:border-0">
            <span class="sr-only">Xemplo</span>
            <img class="h-8 w-auto sm:h-10" src="/logo.svg" alt="xemplo" />
          </a>
        </div>
      </div>

      <a class="flex text-blue-500 cursor-pointer invisible">
        <ChevronLeftIcon size="1.5x" class="mt-0.5 text-black" />
        <span class="hidden md:block">Fee Agreements</span>
      </a>

      <button
        v-if="showFooter"
        :class="`btn btn--default mr-2 text-black ${
          needHelpButton.isClicked
            ? 'disabled opacity-20 cursor-not-allowed'
            : ''
        }`"
        @click="buttonClicked('needHelp')"
      >
        Need Help?
      </button>
    </div>
    <div class="w-full">
      <div style="position: fixed; bottom: 3%; width: 100%; z-index: 9999;">
        <div class="mx-auto max-w-screen-1920 px-8"  v-if="haveFooter">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-start-1 lg:col-start-2 col-span-12 lg:col-span-10">
              <div class="opacity-20"></div>
              <div class="flex justify-center">
                <button
                  :class="`btn btn--primary text-white ${
                    continueButton.isClicked || !continueButton.isEnabled
                      ? 'disabled opacity-20 cursor-not-allowed'
                      : ''
                  }`"
                  @click="buttonClicked('continue')"
                >
                  {{ continueButton.text }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="showFooter">
        <div
          :class="`dark:bg-darkPrimary mx-4 mb-4 rounded-md relative pt-4 lg:pt-0 px-4 overflow-x-hidden overflow-y-auto`"
          style="max-height: calc(100vh - 165px)"
        >
          <div class="mx-auto max-w-screen-1920" id="wrapper">
            <router-view></router-view>
          </div>
        </div>
      </template>

      <template v-else>
        <div
          :class="`dark:bg-darkPrimary mx-4 mb-4 rounded-md relative pt-4 lg:pt-0 px-4 overflow-visible`"
          style="max-height: calc(100vh - 100px)"
        >
          <div class="mx-auto max-w-screen-1920">
            <router-view></router-view>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { bus } from "@/js/Bus";
import ContactUsFormModal from "@/components/modals/ContactUs";
import { ChevronLeftIcon } from "vue-feather-icons";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DefaultContainer",
  components: {
    ContactUsFormModal,
    ChevronLeftIcon,
  },
  data() {
    return {
      isAuth: false,
      user: null,
      haveFooter: true
    };
  },
  watch: {
    showFooter: function (val) {
      this.haveFooter = val
    }
  },
  methods: {
    ...mapActions({
      setContinueButton: "client/setContinueButton",
      setNeedHelpButton: "client/setNeedHelpButton",
      setShowFooter: 'client/setShowFooter',
    }),
    buttonClicked(type) {
      if (type === "continue") {
        if (!this.continueButton.isClicked && this.continueButton.isEnabled) {
          this.setContinueButton({ isClicked: true, text: "saving..." });
        }
      } else if (type === "needHelp" && this.needHelpButton.isEnabled) {
        if (!this.needHelpButton.isClicked) {
          this.setNeedHelpButton({ isClicked: true });
        }
      }
    },
    scrollTop: function () {
      document.getElementById("wrapper").scrollIntoView();
    },
    navigateToClientPortal() {
      let a = document.createElement("a");
      a.href = process.env.VUE_APP_CLIENT_PORTAL + `/fee-agreements`;
      a.click();
    },

    setAuthenticatedUser() {
      var vm = this;

      this.$http.get(window.app.version + "/user").then(function (response) {
        vm.user = response.data;
      });
    },

    init() {
      var vm = this;
      if (this.$auth.authenticated()) {
        vm.isAuth = true;
        //vm.setAuthenticatedUser();
      }
    },
  },

  created() {
    this.setShowFooter(true);
  },
  mounted() {
    this.setShowFooter(true);
  },

  computed: {
    ...mapGetters({
      project: "client/getProject",
      client: "client/getClient",
      needHelpButton: "client/needHelpButton",
      continueButton: "client/continueButton",
      showFooter: "client/showFooter",
    }),

    projectName() {
      let project = this.project;
      let projectName = "";
      if (project) {
        projectName += project.visa.visa_subclass;
        projectName += project.visa.stream ? " - " + project.visa.stream : "";
      }

      return projectName;
    },
    clientName() {
      let client = this.client;
      return client ? client.name : "";
    },
  },
};
</script>
